<template>


  <div id='' class='' v-loading=false>


    <div class='gPageBorder'>
      <div style='width:calc(100% - 24px);height:100%;background: none;padding-left:24px;padding-bottom:24px;'>
        <div style='height:64px;'>
          <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{detail ? detail.fileName : ''}}</button>
        </div>
        <div style='height:30px;'>
          <table class='dt-pushed'>
            <tr style=''>
              <td >
                <label class='dt-word-title'>{{$t('app_version')}}：</label>
                <label class='dt-word-main'>{{detail? detail.version : ''}}</label>
              </td>
              <td style=''>
                <label class='dt-word-title'>{{$t('app_fileSize')}}：</label>
                <label class='dt-word-main'>{{detail? detail.size : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_distributor')}}：</label>
                <label class='dt-word-main'>{{detail? detail.mechanismName : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_ulTime')}}：</label>
                <label class='dt-word-main'>{{detail? detail.createTime : ''}}</label>
              </td>
             
            </tr>
          </table>
        </div>
        <div style='background:none;min-height:10px;display:flex;display:-webkit-flex;'>
          <div class='dt-word-title' style='display:inline-block;min-width:70px;'>
            {{$t('app_skintro')}}：
          </div>
          <div class='dt-word-main' style='display:inline-block;position:relative;background:none;margin: 0 24px 24px 0;'>
            <pre>{{detail? detail.memo : ''}}</pre>
          </div>
        </div>

    

      </div>
    </div>

    
    <div class='gPageBorder gTopMg'>
      <el-row>
        <el-col :span='4'>
          <el-button class='gSgLeftBtn' @click='allDel'>{{$t('app_mulDel')}} ({{sNum}})</el-button>
        </el-col>

        <el-col :span='12'>
          <div class='gSpDiv'></div>
        </el-col>


        <el-col :span='4'>
          <div class='gCtrl'>
            <el-select  v-model="statusVl" clearable :placeholder="$t('app_status')" @change='selectChange'>
              <el-option
                v-for="item in status"
                :key="item.vl"
                :label="item.name"
                :value="item.vl">
              </el-option>
            </el-select>
          </div>
        </el-col>

        
        <el-col :span='4'>
          <div class='gSideCtrl'><el-input  :placeholder="$t('app_deviceName')+'/'+$t('app_deviceNo')" @keyup.enter.native='query' v-model='tName' icon='search' :on-icon-click='query'></el-input></div>
        </el-col>
        
      </el-row>

      <div id='cmData'>
        <el-table
          class='gTopMg'
          ref="multipleTable"
          @row-click='cellClick'
          :data="tableData"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%">
          <el-table-column
              align=center
              type="selection"
              width="55">
          </el-table-column>
          

          <el-table-column
            header-align='center'
            align='center'
            prop="terminalName"
            :label="$t('app_deviceName')"
            width="">
            <template slot-scope='scope'>
              <label style=''>{{scope.row.terminalName}}</label>
            </template>
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            prop="terminalNo"
            :label="$t('app_deviceNo')"
            width="">
            <template slot-scope='scope'>
              <label style=''>{{scope.row.terminalNo}}</label>
            </template>
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            :label="$t('app_status')"
            width="">
            <template slot-scope='scope'>
              <!-- <label>{{scope.row.data ? statusNames[scope.row.data.result.status] : statusNames[scope.row.status]}}</label> -->
              <label typy="success">{{statusNames[scope.row.taskStatus]}}</label>
            </template>
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            prop="createTime"
            :label="$t('app_azcgsj')"
            width="">
            
          </el-table-column>

          <el-table-column
            header-align='center'
            align=center
            prop="cancelNums"
            :label="$t('app_operate')"
            width="106">
            <template slot-scope='scope'>
              
              

              <!-- <el-button  type=text v-show='showBtn(1, scope.row.status)' @click='downOperate(2, scope.row)'>{{$t('app_pause')}}</el-button> -->
              <el-tooltip class="item" effect="dark" :content="$t('app_pause')" placement="top">
                <el-button type='text' v-show='showBtn(1, scope.row.taskStatus)' @click='downOperate(2, scope.row)'><i class="fa fa-pause" style=""></i></el-button>
              </el-tooltip>

              <!-- <el-button type=text v-show='showBtn(2, scope.row.status)' @click='downOperate(1, scope.row)'>{{$t('app_continue')}}</el-button> -->
              <el-tooltip class="item" effect="dark" :content="$t('app_continue')" placement="top">
                <el-button type='text' v-show='showBtn(2, scope.row.taskStatus)' @click='downOperate(1, scope.row)'><i class="fa fa-play" style=""></i></el-button>
              </el-tooltip>

              <!-- <el-button type=text v-show='showBtn(3, scope.row.status)' @click='downOperate(3, scope.row)'>{{$t('app_cancel')}}</el-button> -->
              <el-tooltip class="item" effect="dark" :content="$t('app_cancel')" placement="top">
                <el-button type='text' v-show='showBtn(3, scope.row.taskStatus)' @click='downOperate(3, scope.row)'><i class="fa fa-window-close" style=""></i></el-button>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
                <el-button type='text' v-show='showBtn(0, scope.row.taskStatus)' @click='delRow(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
              </el-tooltip>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class='gPgDiv'>


        <el-pagination
          class='gPg'
          @current-change="pageSelect"
          @size-change="pageSized"
          :current-page="index"
          :page-sizes='$gRows'
          :page-size="row"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
          </el-pagination>
      </div>
    </div>
  </div>
</template>

<style>
.dt-pushed{background: none;width:100%;}
</style>

<script>
  export default{
    data () {
      return {
        sNum: 0,
        index: 1,
        refresh: 2000,
        multipleSelection: [],
        name: '',
        tContent: '',
        row: this.$gRow,
        total: 0,
        dialogFormVisible: 0,
        tableData: [],
        pInfo: [], // 进度处理
        loading: 0,
        editData: '',
        info: '',
        detail: '',
        statusNames: { // add by sing, 2017-06-17
          '-1': this.$t('app_downFail'),
          '-2': this.$t('app_md5Fail'),
          '-3': this.$t('app_theNewgVer'),
          '-4': this.$t('app_fileFmIllegal'),
          '-5': this.$t('app_updateFail'),
          '-6': this.$t('app_usrCancelUpdate'),
          '-10': this.$t('app_uninsfail'),
          '0': this.$t('app_pushFail'),
          '1': this.$t('app_downloading'),
          '2': this.$t('app_downFinish'),
          '3': this.$t('app_success'),
          '6': this.$t('app_pause'),
          '7': this.$t('app_cancel'),
          '5': this.$t('app_success')
        },
        status: [
          {vl: '-1', name: this.$t('app_downFail')},
          {vl: '-2', name: this.$t('app_md5Fail')},
          {vl: '-3', name: this.$t('app_newgVer')},
          {vl: '-4', name: this.$t('app_fileFmIllegal')},
          {vl: '-5', name: this.$t('app_updateFail')},
          {vl: '-6', name: this.$t('app_usrCancelUpdate')},
          {vl: '-10', name: this.$t('app_uninsfail')},
          {vl: '0', name: this.$t('app_pushFail')},
          {vl: '1', name: this.$t('app_downloading')},
          {vl: '2', name: this.$t('app_downFinish')},
          {vl: '3', name: this.$t('app_success')},
          {vl: '6', name: this.$t('app_pause')},
          {vl: '7', name: this.$t('app_cancel')},
          {vl: '5', name: this.$t('app_success')},
        ],
        statusVl: '',
        tName: ''
      }
    },
    computed: {
      /* index () {
        return this.$getWPage('missionDetailPage')
      } */
    },
    methods: {
      cellClick (row, ev, col) {

        return

        if (col.label && col.label === this.$t('app_operate')) {
          return
        }

        if (col.label === this.$t('app_deviceName') || col.label === this.$t('app_deviceNo')) {
          
          /*var obj={
            terId:row.terminalId,
            terNo:row.terminalNo,
            ter: row
          } 
          this.$store.dispatch('setTerParam',obj)*/
          this.$router.push({
            path: '/terList/' + row.terminalId + '/details'
          })
          
        }

       

        //this.$setWObj('editAppConfig', cf)
        //this.$router.push({name: this.$t(name)})
      },
      /* processFinish () {
        clearTimeout(this.fTm)
        this.fTm = setInterval(() => {
          var is = 0
          this.tableData.forEach((vl) => {
            if (vl.status === '2') {
              //...
              is = 1
            }
          })
          if (is) {
            this.getList()
          } else {
            clearTimeout(this.fTm)
          }
        }, this.refresh)
      }, */
      allDel () {
        var hit = 0
        this.multipleSelection.forEach((vl) => {
          if (vl.status === '1' ||
          vl.status === '1' ||
          vl.status === '6') {
            hit = 1
            return
          }
        })
        if (hit) {
          this.$message.error(this.$t('app_cantDelTask'))
        } else {
          var ids = ''
          this.multipleSelection.forEach((vl) => {
            ids += vl.id + ','
          })
          ids = ids.substring(0, ids.length - 1)
          if (!ids) {
            this.$message(this.$t('app_oneRecordMust'))
            return
          }
          this.loading = 1
          this.$pushDelTask(ids, (res) => {
            // this.delDeviceNo = 0
            this.loading = 0
            if (res.status === 200) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        }
      },
      handleSelectionChange (val) {
        this.sNum = val.length
        this.multipleSelection = val
        if (this.multipleSelection.length > 0) {
          this.stopTimer()
        } else {
          this.updateTimer()
        }
      },
      query () {
        this.getList()
      },
      selectChange (vl) {
        this.getList()
      },
      downOperate (vl, row) {
        console.log(row.terminalNo)
        this.loading = 1
        this.$pushFileDownCtrl(row.id, vl + '', row.terminalNo, (res) => {
          console.log('opres', res)
          this.loading = 0
          if (res.status === 200) {
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
      },
      getProcess (mIds) {
        if (!mIds) {
          this.stopTimer()
          return
        }
        //console.log(this.$route.path)
        
        this.$missionPersent(mIds, (res) => {
          if (res.status === 200) {
            //console.log(res)
            var temp = []
            this.pInfo.forEach((vl, index) => {
              var newData = vl
              var data = res.data[index]
              if (data.result) {
                newData.value.progress = data.result.progress
                newData.value.status = data.result.status
              } else {
                this.getList()
              }
              temp.push(newData)
            })
            this.pInfo = temp
            // 把数据贴到缓存中

            this.pInfo.forEach((vl, index) => {
              this.tableData[vl.index] = vl.value
            })
            // 数据更新完成
            // console.log(res)
            // console.log(this.tableData)


          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
        })
      },
      processCore () {
        var arr = this.tableData
        this.pInfo = []
        this.tableData.forEach((vl, index) => {
          if (vl.taskStatus === '1' || vl.taskStatus === '2') {
            this.pInfo.push({value: vl, index: index})
          }
        })
        var ids = ''
        this.pInfo.forEach((vl, index) => {
          
          ids += vl.value.id + ','
        })
        ids = ids.substring(0, ids.length - 1)
        this.getProcess(ids)
      },
      updateTimer () {
        this.stopTimer()

        if (this.$route.path !== '/mission-detail') {
          return
        }
        this.pTm = setInterval(() => {
          // console.log('tm go')
          this.processCore()
        }, this.refresh)
      },
      stopTimer () {
        clearInterval(this.pTm)
        clearTimeout(this.pTm)
        //console.log(this.pTm, this.fTm)
      },
      showBtn (tag, st) {
        // tag 0删除 1暂停 2继续 3取消
        // st (0失败、1正在下载、2暂停、3取消、4完成)
        // 新状态，modify by sing, 2017-06-17
        // st -1： 下载失败， -2： MD5校验失败， -3： 已经是最新版本，
        // -4： 文件格式不正确（不是apk文件）， -5： 更新失败，-6：用户取更，
        // 1： 下载中，返回下载进度，2： 下载完成， 3： 更新成功，6暂停 7取消
        var vl = st;
        // console.log('tag is ' + tag + ',status: ' + JSON.stringify(st));
        switch (vl) {
          case '-1':
          case '-2':
          case '-3':
          case '-4':
          case '-5':
          case '-6':
          case '3':
          case '2':
          case '0':
          case '7':
            if (tag === 0) {
              return 1
            } else {
              return 0
            }
            break
          case '1':
            if (tag === 1 || tag === 3) {
              return 1
            } else {
              return 0
            }
            break
          case '6':
            if (tag === 2 || tag === 3) {
              return 1
            } else {
              return 0
            }
            break
        }
        //updateTimer
      },
      delRow (row) {
        this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', () => {
          // sure
          //console.log(row)
          var id = row.id
          this.loading = 1
          this.$pushDelTask(id, (res) => {
            // this.delDeviceNo = 0
            this.loading = 0
            if (res.status === 200) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        })
        // console.log(row)
      },
      pageSelect (index) {
        this.index = index
        this.getList()
        // this.$setWPage('missionDetailPage', index)
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      getList () {
        var tNameVl = this.tName ? this.tName : ''
        var statusVl = this.statusVl ? this.statusVl : ''
        var content = this.tContent? this.tContent : ''
        this.loading = 1
        
        this.$pushHisDetail(this.index, this.$gRow, this.info.fileId, this.info.version, tNameVl, statusVl, this.info.taskType, (res) => {
          this.loading = 0
          console.log(res)
          if (res.status === 200) {
            
            this.tableData = res.data
            this.total = res.total
            //this.updateTimer() 
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      getDetail () {
        this.loading = true
        this.$pushFileDetail(this.info.fileId, this.info.taskType, (res) => {
          this.loading = false
          if (res.status === 200) {
            //console.log(res.data)
            this.detail = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = false
        })
      }
    },
    mounted () {
      this.info = this.$getWObj().missionInfo
      
      this.getList()
      this.getDetail()
    },
    destroyed () {
      this.stopTimer()
      
    }
  }
</script>



// WEBPACK FOOTER //
// Hisdetail.vue?23632f42